import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Loader from "../../ui/Loader";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import SelectDropdown from "../../components-react/SelectDropdown";
import {
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchMemberSubscriptionData } from "../../../redux/plans-reducers/plansSlice";
import "../../../styles/transfer/gym-transfer.css";
import { fetchGymData } from "../../../data/APIs";

const validateForm = (formValues) => {
  let errors = {};
  const mobileRegex = /^\d{10}$/;

  if (!formValues.memberMobile) {
    errors.memberMobile = "Member Number Required!";
  } else if (!mobileRegex.test(formValues.memberMobile)) {
    errors.memberMobile = "Invalid mobile number!";
  }

  if (!formValues.selectedMemberGym) {
    errors.selectedMemberGym = "Required!";
  }

  if (!formValues.selectedGym) {
    errors.selectedGym = "Required!";
  } else if (
    formValues.selectedMemberGym?.value === formValues.selectedGym?.value
  ) {
    errors.selectedGym = "Gym cannot be the same as the source gym!";
  }

  // if (
  //   memberFetchedData &&
  //   memberFetchedData.some(
  //     (item) =>
  //       item.type === "addon_pt" && item.subscription_status === "active"
  //   ) &&
  //   !formValues.ptSubscriptionId
  // ) {
  //   errors.ptSubscription = "Please select a PT plan for transfer";
  // }

  // if (formValues.hasPT && !formValues.selectedTrainer) {
  //   errors.selectedTrainer = "Trainer selection required for PT transfer!";
  // }

  // if (formValues.hasPT && !formValues.selectedSlotIndex) {
  //   errors.selectedSlotIndex = "Slot selection required for PT transfer!";
  // }

  if (!formValues.processingFee) {
    errors.processingFee = "Processing fee is required!";
  } else if (Number(formValues.processingFee) < 0) {
    errors.processingFee = "Processing fee cannot be negative!";
  }

  return errors;
};

const GymTransferForm = ({ userInfoData, callFunction, closeModal }) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { postPutLoading } = useSelector((state) => state.common);
  const {
    memberSubscription,
    memberSubscriptionLoading,
    memberSubscriptionError,
  } = useSelector((state) => state.plans);
  const {
    allTrainerByExpLvlData,
    loading: trainerLoading,
    error,
  } = useSelector((state) => state.api);
  // const { trainerShifts, loading: trainerSlotLoading } = useSelector(
  //   (state) => state.dropdown
  // );

  // State for member information
  const [isFetchUser, setIsFetchUser] = useState(false);
  const [memberFetchedData, setMemberFetchedData] = useState(null);
  const iniMemStatus = {
    isShowForm: false,
    errorMessage: "",
  };
  const [memberStatus, setMemberStatus] = useState(iniMemStatus);
  const [allGymTrainers, setAllGymTrainers] = useState([]);
  const [showPTSection, setShowPTSection] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    regular: false,
    pt: false,
  });

  // const [selectedPlan, setSelectedPlan] = useState(null);

  // Form state
  const iniFormValues = {
    memberMobile: "",
    memberName: "",
    memberEmail: "",
    selectedMemberGym: "",
    memberInfo: "",

    selectedGym: "",
    hasPT: false,

    processingFee: "",
    isCustomFee: false,
    remarks: "",

    // selectedTrainer: "",
    // selectedSlotIndex: "",
    // selectedSlotStartTime: "",
    // selectedSlotEndTime: "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  // Handle input changes
  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    if (name === "memberMobile" && value.length > 10) {
      return;
    }

    if (name === "processingFee" && Number(value) < 0) {
      return;
    }

    if (name === "isCustomFee") {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: checked,
        processingFee: checked
          ? prevs.processingFee
          : prevs.selectedGym?.info?.gym_transfer_fee || "",
      }));
    } else if (name === "processingFee") {
      const newValue = value;
      const isCustom = parseFloat(newValue) !== "";

      setFormValues((prevs) => ({
        ...prevs,
        [name]: newValue,
        isCustomFee: isCustom,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  // Handle dropdown changes
  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);

    if (name === "selectedGym") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        processingFee: value?.info?.gym_transfer_fee || "",
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Handle PT subscription selection
  // const handleSelect = (subsId, type) => {
  //   if (type === "pt") {
  //     setFormValues((prevs) => ({
  //       ...prevs,
  //       ptSubscriptionId: subsId === prevs.ptSubscriptionId ? "" : subsId,
  //       hasPT: subsId !== prevs.ptSubscriptionId,
  //     }));

  //     setShowPTSection(subsId !== formValues.ptSubscriptionId);

  //     if (subsId === formValues.ptSubscriptionId) {
  //       setFormValues((prevs) => ({
  //         ...prevs,
  //         selectedTrainer: "",
  //         selectedSlotIndex: "",
  //         selectedSlotStartTime: "",
  //         selectedSlotEndTime: "",
  //       }));
  //     }
  //   } else {
  //     setFormValues((prevs) => ({
  //       ...prevs,
  //       regularSubscriptionId:
  //         subsId === prevs.regularSubscriptionId ? "" : subsId,
  //     }));
  //   }
  // };

  // Handle slot selection
  // const handleSelectSlot = (index, start, end) => {
  //   if (index === formValues.selectedSlotIndex) {
  //     setFormValues((prevs) => ({
  //       ...prevs,
  //       selectedSlotIndex: "",
  //       selectedSlotStartTime: "",
  //       selectedSlotEndTime: "",
  //     }));
  //   } else {
  //     setFormValues((prevs) => ({
  //       ...prevs,
  //       selectedSlotIndex: index,
  //       selectedSlotStartTime: start,
  //       selectedSlotEndTime: end,
  //     }));
  //   }
  // };

  // Handle form submission
  const onSumitForm = (e) => {
    e.preventDefault();
    setFormErrors(validateForm(formValues, memberFetchedData));
    setIsSubmit(true);
  };

  // Fetch member details
  function getMemberDetails(filters) {
    dispatch(
      fetchMemberSubscriptionData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  // Click handler for fetching user details
  function onClickFetchUserDetails(e) {
    e.preventDefault();

    if (!formValues.memberMobile) {
      setMemberFetchedData(null);
      setMemberStatus({
        isShowForm: false,
        errorMessage: "Please enter a valid member number",
      });

      return;
    }

    if (formValues.memberMobile && !formErrors.memberMobile) {
      const filters = {
        mobile_number: formValues.memberMobile,
      };

      setIsFetchUser(true);
      getMemberDetails(filters);
    }
  }

  function onClearNumber(e) {
    e && e.preventDefault();

    const handleConfirm = () => {
      setFormValues(iniFormValues);
      setIsSubmit(false);
      setIsFetchUser(false);
      setMemberFetchedData(null);
      setMemberStatus(iniMemStatus);
      setShowPTSection(false);
    };

    showConfirmAlert(handleConfirm, `You want to clear the form?`);
  }

  // Get subscription progress
  const getSubsProgress = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const today = new Date();

    const totalDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
    const daysLeft = Math.ceil((end - today) / (1000 * 60 * 60 * 24));

    return {
      daysLeft: daysLeft > 0 ? daysLeft : 0,
      totalDays: totalDays,
    };
  };

  const toggleSection = (section) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section],
    });
  };

  const handleSubmitForm = async (payload) => {
    try {
      const method = "POST";
      const endpoint = "/gym/transfer";
      const token = userInfoData?.token || "";

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(iniFormValues);
        setIsFetchUser(false);
        setMemberFetchedData(null);
        setMemberStatus(iniMemStatus);
        setShowPTSection(false);
        callFunction();
        closeModal();
        toast.success(
          result?.payload?.message ||
            "Gym transfer initiated successfully! Payment link sent to member."
        );
      } else {
        const errorMessage =
          result?.payload?.data ||
          result?.payload?.message ||
          result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error processing gym transfer:", error);
      toast.error("Failed to process gym transfer");
    }
  };

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    if (
      isFetchUser &&
      !memberSubscriptionLoading &&
      !formErrors.memberMobile &&
      !memberSubscriptionError &&
      memberSubscription?.status &&
      memberSubscription?.data?.length > 0
    ) {
      const memberData = memberSubscription.data;
      const { gym_name, gym_id, user_name, user_email, subscription_status } =
        memberData[0];

      const hasActivePT = memberData.some(
        (item) =>
          item.type === "addon_pt" &&
          (item.subscription_status === "active" ||
            item.subscription_status === "draft")
      );

      if (hasActivePT) {
        setMemberStatus({
          isShowForm: false,
          errorMessage:
            "This member has active PT plan so its membership cannot be transferred.",
        });
        setIsFetchUser(false);
        return;
      }

      setFormValues((prevs) => ({
        ...prevs,
        memberName: user_name,
        memberEmail: user_email,
        selectedMemberGym: {
          label: gym_name,
          value: gym_id,
        },
        memberInfo: memberData[0],
      }));

      setMemberFetchedData(memberData);
      setMemberStatus({
        isShowForm: true,
        errorMessage: "",
      });
      setIsFetchUser(false);
    } else if (
      isFetchUser &&
      !memberSubscriptionLoading &&
      !memberSubscriptionError &&
      (!memberSubscription?.status || memberSubscription?.data?.length === 0)
    ) {
      setMemberStatus({
        isShowForm: false,
        errorMessage: "No active memberships found for this member.",
      });
      setIsFetchUser(false);
    }
  }, [
    isFetchUser,
    memberSubscriptionLoading,
    memberSubscriptionError,
    formErrors.memberMobile,
    memberSubscription,
  ]);

  // Fetch trainers when gym is selected and PT is being transferred
  // useEffect(() => {
  //   if (formValues.selectedGym?.value && formValues.hasPT) {
  //     const qp = `&gym_id=${formValues.selectedGym.value}&status=active`;

  //     dispatch(
  //       fetchAllTrainersByExpLvlData({
  //         queryParameters: qp,
  //         token: userInfoData?.token,
  //       })
  //     );
  //   }
  // }, [formValues.selectedGym, formValues.hasPT]);

  // Fetch trainer slots when trainer is selected
  // useEffect(() => {
  //   if (formValues.selectedTrainer?.value) {
  //     const filter = {
  //       trainer_id: formValues.selectedTrainer.value,
  //     };

  //     dispatch(
  //       fetchTrainerShiftsData({
  //         filters: filter,
  //         token: userInfoData?.token,
  //       })
  //     );
  //   }
  // }, [formValues.selectedTrainer]);

  // Process trainer data
  useEffect(() => {
    if (
      !trainerLoading &&
      !error &&
      allTrainerByExpLvlData?.status &&
      allTrainerByExpLvlData?.data
    ) {
      const slots = allTrainerByExpLvlData.data?.slot_details || [];
      const trainers = allTrainerByExpLvlData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
        slot: slots,
        info: item,
      }));

      setAllGymTrainers(trainers);
    } else {
      setAllGymTrainers([]);
    }
  }, [trainerLoading, error, allTrainerByExpLvlData]);

  // Process form submission when validation passes
  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const payload = {
        user_from: formValues.memberInfo?.user_id || "",
        transfered_type: "gym",
        gym_from: formValues.selectedMemberGym?.value || "",
        gym_to: formValues.selectedGym?.value || "",
        transfered_fee: formValues.processingFee || 0,
        payment_by: "self",
        is_custom:
          formValues.isCustomFee &&
          Number(formValues.processingFee || 0) !==
            Number(formValues.memberInfo?.subscription_transfer_fee || 0)
            ? 1
            : 0,
      };

      const handleConfirm = async () => {
        handleSubmitForm(payload);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to proceed with this gym transfer?`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  console.log(formValues.selectedGym);

  return (
    <div className="form-container transfer-form-container">
      <form className="formContainer mb150">
        <div className="formInputsGrid twoGridSystem input-with-btn">
          <div className="formInputBox">
            <label htmlFor="memberMobile" className={`formInputLabel`}>
              Member Mobile <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Enter Member Mobile Number"
              className={`formInput ${
                formErrors?.memberMobile ? "formError" : ""
              }`}
              name="memberMobile"
              value={formValues.memberMobile}
              onChange={onChangeInput}
              maxLength={10}
            />

            <span className="error-label">
              {formErrors?.memberMobile || ""}
            </span>

            {!memberStatus.isShowForm && memberStatus.errorMessage && (
              <span className="info">{memberStatus.errorMessage || ""}</span>
            )}
          </div>

          <div className="formInputButtons">
            <Button
              type="button"
              className="saveBtn"
              variant="danger"
              onClick={onClickFetchUserDetails}
              disabled={memberFetchedData || formErrors.memberMobile}>
              {memberSubscriptionLoading ? <Loader /> : "Fetch Member Details"}
            </Button>
            {!memberSubscriptionLoading && (
              <Button
                type="button"
                className="cancelBtn"
                variant="dark"
                onClick={onClearNumber}>
                Clear
              </Button>
            )}
          </div>
        </div>

        {memberStatus.isShowForm && (
          <>
            <div className="formInputsGrid twoGridSystem">
              <div className="formInputBox">
                <label htmlFor="memberName" className={`formInputLabel`}>
                  Member Name
                </label>

                <input
                  type="text"
                  placeholder="Enter Member Full Name"
                  className={`formInput ${
                    formErrors?.memberName ? "formError" : ""
                  }`}
                  name="memberName"
                  value={formValues.memberName}
                  onChange={onChangeInput}
                  disabled
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="memberMobile" className={`formInputLabel`}>
                  Member Mobile
                </label>

                <input
                  type="text"
                  placeholder="Enter Member Mobile"
                  className={`formInput ${
                    formErrors?.memberMobile ? "formError" : ""
                  }`}
                  name="memberMobile"
                  value={formValues.memberMobile}
                  onChange={onChangeInput}
                  disabled
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="memberEmail" className={`formInputLabel`}>
                  Member Email
                </label>

                <input
                  type="email"
                  placeholder="Enter Member Email"
                  className={`formInput ${
                    formErrors?.memberEmail ? "formError" : ""
                  }`}
                  name="memberEmail"
                  value={formValues.memberEmail}
                  onChange={onChangeInput}
                  disabled
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="selectedMemberGym" className={`formInputLabel`}>
                  Transferred From (Gym) <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedMemberGym ? "formError" : ""
                  } disabled`}>
                  <SelectDropdown
                    options={gymData?.length > 0 ? gymData : []}
                    selectedOption={formValues.selectedMemberGym}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedMemberGym", selectedValue)
                    }
                    name="Transferred From"
                    isDisable={true}
                  />
                </div>

                <span className="error-label">
                  {formErrors?.selectedMemberGym || ""}
                </span>
              </div>

              <div className="formInputBox">
                <label htmlFor="selectedGym" className={`formInputLabel`}>
                  Transfer To (Gym) <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedGym ? "formError" : ""
                  }`}>
                  <SelectDropdown
                    options={gymData?.length > 0 ? gymData : []}
                    selectedOption={formValues.selectedGym}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedGym", selectedValue)
                    }
                    name="Gym"
                  />
                </div>

                <span className="error-label">
                  {formErrors?.selectedGym || ""}
                </span>
              </div>
            </div>

            {/* Processing Fee Section */}
            <div className="processing-fee-section">
              <div className="formInputBox">
                <label htmlFor="processingFee" className={`formInputLabel`}>
                  Processing Fee <span className="required">*</span>
                </label>

                <div className="processing-fee-wrapper">
                  <input
                    type="number"
                    placeholder="Enter Processing Fee"
                    className={`formInput ${
                      formErrors?.processingFee ? "formError" : ""
                    }`}
                    name="processingFee"
                    value={formValues.processingFee}
                    onChange={onChangeInput}
                    disabled={!formValues.isCustomFee}
                    min="0"
                  />

                  <div className="manual-fee-toggle">
                    <input
                      type="checkbox"
                      id="isCustomFee"
                      name="isCustomFee"
                      checked={formValues.isCustomFee}
                      onChange={onChangeInput}
                      className="custom-checkbox"
                    />
                    <label
                      htmlFor="isCustomFee"
                      className="custom-checkbox-label">
                      Manual Fee
                    </label>
                  </div>
                </div>

                <span className="error-label">
                  {formErrors?.processingFee || ""}
                </span>
              </div>

              {formValues.isCustomFee && (
                <div className="alert-box warning">
                  <div className="alert-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                      <line x1="12" y1="9" x2="12" y2="13"></line>
                      <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>
                  </div>
                  <div className="alert-content">
                    <p>
                      Important: Manual gym transfer fee requires administrator
                      approval. After submitting this form, the transfer request
                      will be placed in a pending state. The gym transfer will
                      only be processed and finalized after an administrator
                      reviews and approves the custom fee amount. This
                      additional step helps ensure all fee adjustments are
                      properly authorized.
                    </p>
                  </div>
                </div>
              )}
            </div>
            {/* Membership Details Section */}
            {memberFetchedData && (
              <div className="memberships-container">
                {/* Regular Memberships */}
                <div className="membership-section">
                  <div
                    className={`section-header ${
                      expandedSections.regular ? "expanded" : ""
                    }`}
                    onClick={() => toggleSection("regular")}>
                    <div className="section-title">
                      Active Regular Memberships
                      <span className="count">
                        {
                          memberFetchedData.filter(
                            (item) =>
                              item.type === "regular" &&
                              (item.subscription_status === "active" ||
                                item.subscription_status === "draft")
                          ).length
                        }
                      </span>
                      {/* <span className="collapsible-indicator">
                        {expandedSections.regular ? 'Click to collapse' : 'Click to expand'}
                      </span> */}
                    </div>
                  </div>

                  <div
                    className={`plans-grid ${
                      expandedSections.regular ? "expanded" : ""
                    }`}>
                    {memberFetchedData.some(
                      (item) =>
                        item.type === "regular" &&
                        (item.subscription_status === "active" ||
                          item.subscription_status === "draft")
                    ) ? (
                      memberFetchedData
                        .filter(
                          (item) =>
                            item.type === "regular" &&
                            (item.subscription_status === "active" ||
                              item.subscription_status === "draft")
                        )
                        .map((item, index) => {
                          const {
                            plan_name,
                            price,
                            start_date,
                            expire_date,
                            uid,
                          } = item || {};

                          const startDate = start_date
                            ? formatDateTimezon(start_date).split(" ")[0]
                            : "-";
                          const endDate = expire_date
                            ? formatDateTimezon(expire_date).split(" ")[0]
                            : "-";
                          const daysLeft = getSubsProgress(
                            start_date,
                            expire_date
                          ).daysLeft;

                          return (
                            <div className="plan-card" key={index}>
                              <div className="plan-header">
                                <div>
                                  <h3 className="plan-name">
                                    {plan_name || "WTF Yearly"}
                                  </h3>
                                  <div className="plan-type">
                                    Regular Membership
                                  </div>
                                </div>
                                <span className="status">
                                  {item.subscription_status === "active"
                                    ? "ACTIVE"
                                    : "DRAFT"}
                                </span>
                              </div>

                              <div className="plan-body">
                                <div className="plan-detail">
                                  <div className="detail-label">Price:</div>
                                  <div className="detail-value price">
                                    ₹{convertThenFormat(price || 0)}
                                  </div>
                                </div>

                                <div className="plan-detail">
                                  <div className="detail-label">Duration:</div>
                                  <div className="detail-value">
                                    {startDate} - {endDate}
                                  </div>
                                </div>

                                <div className="plan-detail">
                                  <div className="detail-label">Remaining:</div>
                                  <div className="detail-value">
                                    <span className="days-left">
                                      {/* <ClockIcon />  */}
                                      {daysLeft} days
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                    ) : (
                      <div className="empty-message">
                        No active regular memberships
                      </div>
                    )}
                  </div>
                </div>

                {/* PT Memberships */}
                <>
                  {/* <div
                    className="membership-section"
                    style={{ display: "none" }}>
                    <div
                      className={`section-header ${
                        expandedSections.pt ? "expanded" : ""
                      } ${formErrors.ptSubscription ? "error" : ""}`}
                      onClick={() => toggleSection("pt")}>
                      <div className="section-title">
                        Personal Training
                        <span className="count" className="sessions-selected">
                          {
                            memberFetchedData.filter(
                              (item) =>
                                item.type === "addon_pt" &&
                                item.subscription_status === "active" &&
                                item.uid === formValues.ptSubscriptionId
                            ).length
                          }
                          /{" "}
                          {
                            memberFetchedData.filter(
                              (item) =>
                                item.type === "addon_pt" &&
                                item.subscription_status === "active"
                            ).length
                          }
                        </span>
                        {formErrors.ptSubscription && (
                          <span className="error-message">
                            {formErrors.ptSubscription}
                          </span>
                        )}
                      </div>
                    </div>

                    <div
                      className={`plans-grid ${
                        expandedSections.pt ? "expanded" : ""
                      }`}>
                      {memberFetchedData.some(
                        (item) =>
                          item.type === "addon_pt" &&
                          item.subscription_status === "active"
                      ) ? (
                        memberFetchedData
                          .filter(
                            (item) =>
                              item.type === "addon_pt" &&
                              item.subscription_status === "active"
                          )
                          .map((item, index) => {
                            const {
                              addon_name,
                              price,
                              start_date,
                              expire_date,
                              uid,
                              trainer_name,
                            } = item || {};

                            const startDate = start_date
                              ? formatDateTimezon(start_date).split(" ")[0]
                              : "-";
                            const endDate = expire_date
                              ? formatDateTimezon(expire_date).split(" ")[0]
                              : "-";
                            const daysLeft = getSubsProgress(
                              start_date,
                              expire_date
                            ).daysLeft;
                            const isSelected = selectedPlan === uid;

                            return (
                              <div
                                className={`plan-card ${
                                  isSelected ? "selected" : ""
                                }`}
                                key={index}>
                                <div className="plan-header">
                                  <div>
                                    <h3 className="plan-name">
                                      {addon_name || "PT Sessions"}
                                    </h3>
                                    <div className="plan-type">
                                      Personal Training
                                    </div>
                                  </div>
                                  <span className="status">ACTIVE</span>
                                </div>

                                <div className="plan-body">
                                  <div className="trainer-box">
                                    <div className="trainer-avatar">
                                      {(trainer_name || "T")[0].toUpperCase()}
                                    </div>
                                    <div className="trainer-info">
                                      <div className="trainer-name">
                                        {trainer_name || "Not assigned"}
                                      </div>
                                      <div className="trainer-title">
                                        Current Trainer
                                      </div>
                                    </div>
                                  </div>

                                  <div className="plan-detail">
                                    <div className="detail-label">Price:</div>
                                    <div className="detail-value price">
                                      ₹{convertThenFormat(price || 0)}
                                    </div>
                                  </div>

                                  <div className="plan-detail">
                                    <div className="detail-label">
                                      Duration:
                                    </div>
                                    <div className="detail-value">
                                      {startDate} to {endDate}
                                    </div>
                                  </div>

                                  <div className="plan-detail">
                                    <div className="detail-label">
                                      Remaining:
                                    </div>
                                    <div className="detail-value">
                                      <span className="days-left">
                                        {daysLeft} days
                                      </span>
                                    </div>
                                  </div>

                                  <button
                                    type="button"
                                    className={`transfer-btn ${
                                      isSelected ? "selected" : ""
                                    }`}
                                    onClick={() => handleSelectPlan(uid)}
                                    disabled={!formValues.selectedGym?.value}
                                    title={
                                      !formValues.selectedGym?.value
                                        ? "Select a gym first"
                                        : ""
                                    }>
                                    {isSelected ? (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round">
                                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                          <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                        </svg>
                                        Selected for Transfer
                                      </>
                                    ) : (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round">
                                          <path d="M7 16V4M7 4L3 8M7 4L11 8"></path>
                                          <path d="M17 8v12M17 20l4-4M17 20l-4-4"></path>
                                        </svg>
                                        Select for Transfer
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div className="empty-message">
                          No active PT memberships
                        </div>
                      )}
                    </div>
                  </div> */}
                </>
              </div>
            )}

            {/* PT Transfer Section */}
            {/* {(showPTSection || formValues.hasPT) && (
              <div
                className="formInputsGrid threeGridSystem"
                style={{ rowGap: "1rem" }}>
                <div className="formInputBox">
                  <label htmlFor="selectedTrainer" className={`formInputLabel`}>
                    Select New Trainer <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      formErrors.selectedTrainer ? "formError" : ""
                    }`}>
                    <SelectDropdown
                      options={allGymTrainers}
                      selectedOption={formValues.selectedTrainer}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown("selectedTrainer", selectedValue)
                      }
                      name="Trainer"
                      isDisable={
                        trainerLoading ||
                        !formValues.selectedGym?.value ||
                        !formValues.hasPT
                      }
                    />
                  </div>

                  <span className="error-label">
                    {formErrors?.selectedTrainer || ""}
                  </span>
                </div>

                {formValues.selectedTrainer?.value && (
                  <>
                    {trainerSlotLoading ? (
                      <Loader />
                    ) : trainerShifts?.length > 0 ? (
                      <div className="formInputBox">
                        <label
                          htmlFor="selectedSlotIndex"
                          className="formInputLabel">
                          Select Slot <span className="required">*</span>
                        </label>

                        <div
                          className={`commonWrapper ${
                            formErrors.selectedSlotIndex ? "formError" : ""
                          }`}>
                          <SelectDropdown
                            options={trainerShifts}
                            selectedOption={formValues.selectedSlotIndex}
                            setSelectedOption={(selectedValue) =>
                              handleSelectSlot(
                                selectedValue,
                                formValues.selectedSlotStartTime,
                                formValues.selectedSlotEndTime
                              )
                            }
                            name="Slot"
                            isDisable={
                              trainerSlotLoading ||
                              !formValues.selectedTrainer?.value
                            }
                          />
                        </div>

                        <span className="error-label">
                          {formErrors?.selectedSlotIndex || ""}
                        </span>
                      </div>
                    ) : (
                      <span
                        className="errorMessage span4"
                        style={{ margin: "0" }}>
                        No slots available
                      </span>
                    )}
                  </>
                )}
              </div>
            )} */}

            <div className="formButtons" style={{ justifyContent: "flex-end" }}>
              <Button
                type="button"
                className="saveBtn"
                variant="danger"
                onClick={onSumitForm}
                disabled={!memberStatus.isShowForm}>
                {postPutLoading ? <Loader /> : "Submit"}
              </Button>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default GymTransferForm;
